import * as $ from 'jquery'

export interface Option {
	color: string;
	value: string;
	selected: boolean;
	label: string;
}

export interface SelectListParams {
	usesChosen: boolean;
	defaultText: string;
	name: string;
	many: boolean;
	onchange: string;
	id: string;
	width: string;
	options: Option[];
}

export interface CheckboxParams {
	minWidth: string;
	many: boolean;
	name: string;
	onchange: string;
	inline: boolean;
	options: Option[];
}

// Was "export default", but then https://github.com/Microsoft/TypeScript/issues/6962
export class OptionWidget {
	static renderSelectList(place:(n:Node) => void, params:SelectListParams) {
		var select = document.createElement('select');
		if (params.usesChosen)
			select.dataset['placeholder'] = params.defaultText;
		select.id   = params.id;
		select.name = params.name;
		if (params.many)
			select.multiple = true;
		select.onchange = <(ev:Event) => void> new Function('event', params.onchange);
		select.onclick  = <(ev:MouseEvent) => void> new Function('event', params.onchange);

		var hasColor             = false;
		var selectedColor:string|null = null;
		var first                = true;

		params.options.forEach(function (option) {
			var opt = document.createElement('option');

			// We only want mark the first item as selected if we arn't dealing with a chosen widget
			if (option.selected || (first && !params.usesChosen)) {
				opt.selected  = true;
				selectedColor = option.color;
				first         = false;
			}

			hasColor  = hasColor || !!option.color;
			opt.value = option.value;
			if (option.color)
				opt.style.backgroundColor = '#' + option.color;
			opt.appendChild(document.createTextNode(option.label));
			select.appendChild(opt);
		});

		if (hasColor) {
			select.style.backgroundColor = '#' + selectedColor;
			$(select).change(function () {
				select.style.backgroundColor = (select.options[select.selectedIndex] as HTMLElement).style.backgroundColor;
			});
		}

		// jQuery.chosen() only works on elements that have already been added to the document.
		place(select);

		if (params.usesChosen) {
			var chosenOptions:ChosenOptions = {};
			if (params.width != null)
				chosenOptions.width = params.width;
			$(select).chosen(chosenOptions);
		}
	}

	static renderCheckboxes(callback:(n:Node) => void, params:CheckboxParams) {
		var div           = document.createElement('div');
		div.style.display = 'inline-block';

		params.options.forEach(function (option) {
			var label              = document.createElement('label');
			label.style.display    = params.inline ? 'inline-block' : 'block';
			label.style.padding    = '0.5em';
			label.style.whiteSpace = 'nowrap';

			if (params.minWidth != null)
				label.style.minWidth = params.minWidth + 'px';
			if (option.color != null)
				label.style.backgroundColor = '#' + option.color;

			var input                 = document.createElement('input');
			input.type                = params.many ? 'checkbox' : 'radio';
			input.value               = option.value;
			input.style.verticalAlign = 'bottom';
			input.style.padding       = '0';
			input.style.margin        = '0';
			input.name                = params.name;
			input.onchange            = <(ev:Event) => void> new Function('event', params.onchange);
			input.onclick             = <(ev:MouseEvent) => void> new Function('event', params.onchange);
			input.checked             = option.selected;

			label.appendChild(input);
			label.appendChild(document.createTextNode(' ' + option.label));

			div.appendChild(label);
		});

		callback(div);
	}
}



// WEBPACK FOOTER //
// ./src/membership3/OptionWidget.ts